var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEOrder = function SvgEOrder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "07.-Minc-Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Menu",
    transform: "translate(-710.000000, -426.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Navigation-Bar-/-HealthScreening",
    transform: "translate(690.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Health-Screening-List",
    transform: "translate(0.000000, 353.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Fill",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Left",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9638736,20 C17.513796,20 17.9595963,20.4438648 17.9595963,21 L17.9595963,22 L6.04040404,22 L6.04040404,21 C6.04040404,20.4477153 6.49309591,20 7.0361267,20 L16.9638736,20 Z M20.1818182,2 C21.1318182,2 21.9177273,2.71397778 21.9939432,3.63131889 L22,3.77777778 L21.9909091,15.4444444 C21.9909091,16.3733333 21.2607045,17.1417778 20.3303091,17.2163 L20.1818182,17.2222222 L13.6363636,17.2222222 L13.6363636,20 L10.3636364,20 L10.3636364,17.2222222 L3.81818182,17.2222222 C2.85954545,17.2222222 2.08140909,16.5002222 2.00599205,15.5897 L2,15.4444444 L2,3.77777778 C2,2.84044444 2.73020455,2.0796 3.66839432,2.00585889 L3.81818182,2 L20.1818182,2 Z M10.1605456,12.4807692 C9.51903798,12.4807692 9,13.0043269 9,13.6442308 C9,14.2841346 9.51903798,14.8076923 10.1605456,14.8076923 C10.8020532,14.8076923 11.3269231,14.2841346 11.3269231,13.6442308 C11.3269231,13.0043269 10.8020532,12.4807692 10.1605456,12.4807692 Z M15.1605456,12.4807692 C14.519038,12.4807692 14,13.0043269 14,13.6442308 C14,14.2841346 14.519038,14.8076923 15.1605456,14.8076923 C15.8020532,14.8076923 16.3269231,14.2841346 16.3269231,13.6442308 C16.3269231,13.0043269 15.8020532,12.4807692 15.1605456,12.4807692 Z M8,4 L6,4 L6,5.25 L7,5.25 L8.86711916,10.2051995 C9.1606708,10.9842643 9.90613257,11.5 10.7386676,11.5 L14.3490995,11.5 C15.0895172,11.5 15.7693529,11.0909427 16.1161514,10.4367644 L17.934,7.00769231 C17.978,6.92692308 18,6.82884615 18,6.73076923 C18,6.41346154 17.7525,6.15384615 17.45,6.15384615 L8.75,6.15384615 L8,4 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEOrder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/e-order.6629d5d9.svg";
export { ForwardRef as ReactComponent };